import { db } from '@/firebase/init'
import { useUserStore } from '@/stores/userStore'
import { SampleArea } from '@team-milva/lab-models/resources'
import type { ISampleArea } from '@team-milva/lab-models/resources'
import { collection, onSnapshot, query, where } from 'firebase/firestore'
import { defineStore } from 'pinia'

export const useSampleAreaStore = defineStore('sampleArea', {
  state: () => ({
    allSampleAreas: [] as SampleArea[],
    unsubscribeAllSampleAreas: null as (() => void) | null,
  }),

  actions: {
    getSampleAreas(): Promise<SampleArea[]> {
      if (this.allSampleAreasLoaded) {
        return Promise.resolve(this.allSampleAreas)
      }

      const userStore = useUserStore()

      return new Promise((resolve) => {
        if (!userStore.currentUser) {
          return resolve([])
        }

        let resolved = false
        const q = query(
          collection(db, 'Apps', '-lab-management-', 'SampleAreas'),
          where('accountID', '==', userStore.currentUser.labAccountID)
        )

        const unsubscribe = onSnapshot(q, (querySnapshot) => {
          const sampleAreas: SampleArea[] = []
          querySnapshot.forEach((docSnap) => {
            sampleAreas.push(new SampleArea(docSnap.data() as ISampleArea))
          })
          this.allSampleAreas = sampleAreas
          this.unsubscribeAllSampleAreas = unsubscribe

          if (!resolved) {
            resolved = true
            resolve(sampleAreas)
          }
        })
      })
    },

    resetStore(): void {
      this.allSampleAreas = []

      if (this.unsubscribeAllSampleAreas) {
        this.unsubscribeAllSampleAreas()
        this.unsubscribeAllSampleAreas = null
      }
    },
  },

  getters: {
    allSampleAreasLoaded: (state) => !!state.unsubscribeAllSampleAreas,
  },
})
